import styled from 'styled-components/macro';

// import theme helpers
import { getColor, getFontWeight } from '../../../util/theme';

const FormSubmit = styled.input`
  border: 0;
  border-radius: 0;

  background-color: ${getColor('accentRed')};

  color: ${getColor('white')};
  font-size: 1.8rem;
  font-weight: ${getFontWeight('medium')};
  text-align: center;

  height: 100%;
  width: 100%;

  cursor: pointer;

  appearance: none;
`;

export default FormSubmit;
